import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import GoalSelectionFooter from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/GoalSelection/Footer';
import GoalSelection from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/GoalSelection/GoalSelection';
import {
  setProvidedGoal,
  setRequestedGoal,
  useProvidedFeedbackData,
  useRequestedFeedbackData,
} from 'screens/performanceReview/components/ContinuousFeedback/Drawers/slice/feedbackSlice';

import { DrawerFooter } from 'uiToolkitV1/BottomDrawer';
import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { setPrimaryScreen, setSecondaryScreen, useCompetencyDrawerState } from '../competencyDrawerSlice';
import { PrimaryDrawerScreens, SecondaryDrawerScreens } from '../types/slice';

export const GoalSelectionPanel = () => {
  const dispatch = useDispatch();

  const { selectedPrimaryScreen } = useCompetencyDrawerState();
  const { goal: requestFbGoal, receiverEmployeeId } = useRequestedFeedbackData();
  const { goal: shareFbGoal, applicableEmployees } = useProvidedFeedbackData();

  const goal = selectedPrimaryScreen === PrimaryDrawerScreens.REQUEST_FEEDBACK ? requestFbGoal : shareFbGoal;

  const receivers =
    selectedPrimaryScreen === PrimaryDrawerScreens.REQUEST_FEEDBACK ? [receiverEmployeeId] : applicableEmployees;

  // eslint-disable-next-line no-shadow
  const onGoalSelect = (goal) => {
    dispatch(
      selectedPrimaryScreen === PrimaryDrawerScreens.REQUEST_FEEDBACK
        ? setRequestedGoal({
            goal,
          })
        : setProvidedGoal({
            goal,
          })
    );
  };

  const closeGoalSelection = () => {
    dispatch(setPrimaryScreen(PrimaryDrawerScreens.COMPETENCY));
    dispatch(
      setSecondaryScreen(
        selectedPrimaryScreen === PrimaryDrawerScreens.REQUEST_FEEDBACK
          ? SecondaryDrawerScreens.REQUEST_FEEDBACK
          : SecondaryDrawerScreens.SHARE_FEEDBACK
      )
    );
  };

  return (
    <Flex flexDir="column" borderRadius="8px" bgColor="#FFFFFF" flex={1}>
      <Box p="12px" pb="8px !important">
        <TextBodyMedium bold>Goal selection</TextBodyMedium>
      </Box>
      <Divider borderColor="#CFD7DF" my={3} />
      <Box p={2} mb="auto" height="100%" overflow="hidden">
        <GoalSelection
          applicableEmployees={receivers}
          onSelect={onGoalSelect}
          // @ts-expect-error 'goal' is possibly 'null'
          selectedId={goal?.uuid}
        />
      </Box>
      <DrawerFooter h="72px" backgroundColor="neutral.F5F7F9">
        <GoalSelectionFooter onCloseSecondaryPanel={closeGoalSelection} onGoalSelect={closeGoalSelection} />
      </DrawerFooter>
    </Flex>
  );
};
